import { render, staticRenderFns } from "./chooseRole.vue?vue&type=template&id=5b2ffa1c&"
import script from "./chooseRole.vue?vue&type=script&lang=js&"
export * from "./chooseRole.vue?vue&type=script&lang=js&"
import style0 from "./chooseRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports